<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3">
        <v-card color="#01b1af" dark height="100">
          <v-row no-gutters class="title pa-4">
            <v-col cols="12" md="8" sm="8">Total Users</v-col>
            <v-col cols="12" md="4" sm="4" class="text-right">{{
              users | numberFormatter
            }}</v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="#062b48" dark height="100">
          <v-row no-gutters class="title pa-4">
            <v-col cols="12" md="8" sm="8">Total Events</v-col>
            <v-col cols="12" md="4" sm="4" class="text-right">{{
              events | numberFormatter
            }}</v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="#01b1af" dark height="100">
          <v-row no-gutters class="title pa-4">
            <v-col cols="12" md="8" sm="8">Event Participants</v-col>
            <v-col cols="12" md="4" sm="4" class="text-right">{{
              participants | numberFormatter
            }}</v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card color="#062b48" dark height="100">
          <v-row no-gutters class="title pa-4">
            <v-col cols="12" md="6" sm="8">Total Sales</v-col>
            <v-col cols="12" md="6" sm="4" class="text-right">{{
              sales | toCurrency
            }}</v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <BarChart
          v-bind="datas1"
          @chartChangeEvent="chartNavigation"
        ></BarChart>
      </v-col>

      <v-col cols="6">
        <BarChart v-bind="datas2"></BarChart>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BarChart from "./../../components/charts/BarChart.vue";
//import LineChart from "./../../components/charts/LineChart";
// import PieChart from "@/components/charts/PieChart";
//import ColumnChart from "./../../components/charts/ColumnChart";
export default {
  components: {
    BarChart,
    //LineChart,
    // PieChart,
    // ColumnChart,
  },
  data() {
    return {
      datas1: {
        heading: "User acquisition",
        type: "users",
        fullscreenFlag: true,
        yTitle: "Users",
        xTitle: "Timeline",
        chartData: [],
      },
      datas2: {
        heading: "Revenue",
        type: "revenue",
        fullscreenFlag: true,
        yTitle: "Revenue",
        xTitle: "Timeline",
        chartData: [],
      },
      datas3: {
        heading: "App Usage History",
        type: "appUsageHistory",
        fullscreenFlag: true,
        yTitle: "Usage",
        xTitle: "Timeline",
        chartData: [],
        loading: true,
      },
      table: [],
      tournament: 0,
      events: 0,
      participants: 0,
      users: 0,
      sales: 0,
      locationAnalytics: {
        loading: false,
        data: {},
        type: null,
        yTitle: "Users",
        xTitle: "Countries",
      },
      deviceAnalytics: {
        loading: false,
        data: {},
        type: null,
        yTitle: "Users",
        xTitle: "Device",
      },
      osAnalytics: {
        loading: false,
        data: {},
        type: null,
        yTitle: "Users",
        xTitle: "Operating System",
      },
    };
  },
  mounted() {
    this.getCardsData();
    this.getTopSelling();
    this.getAppUsageHistory();
    this.getAnalyticsByLocation();
    this.getAnalyticsByDevice();
    this.getAnalyticsByOs();
    this.$store.dispatch("reportCount");
    if (process.env.NODE_ENV == "development") {
      this.datas3.chartData = [];
      this.datas2.chartData = [
        ["Sun", 32],
        ["Mon", 46],
        ["Tue", 28],
      ];
    }
  },
  methods: {
    chartNavigation(data) {
      let url = "admin/dashboard/";
      let params = {};
      if (data.chart == "users") {
        url += "number-of-mobile-users";
        if (data.type == "day") {
          params = {
            "period-type": "dateWiseNumberofMobileUsers",
            "start-date": data.from,
            "end-date": data.to,
          };
        } else if (data.type == "month") {
          params = {
            "period-type": "monthWiseNumberofMobileUsers",
            "start-month": data.from,
            "end-month": data.to,
          };
        } else if (data.type == "year") {
          params = {
            "period-type": "yearWiseNumberofMobileUsers",
            "start-year": data.from,
            "end-year": data.to,
          };
        }
      } else if (data.chart == "revenue") {
        url += "total-sales-of-bookings";
        if (data.type == "day") {
          params = {
            "period-type": "dateWiseTotalSalesOfBookings",
            "start-date": data.from,
            "end-date": data.to,
          };
        } else if (data.type == "month") {
          params = {
            "period-type": "monthWiseTotalSalesOfBookings",
            "start-month": data.from,
            "end-month": data.to,
          };
        } else if (data.type == "year") {
          params = {
            "period-type": "yearWiseTotalSaleBookings",
            "start-year": data.from,
            "end-year": data.to,
          };
        }
      } else if (data.chart == "appUsageHistory") {
        url += "total-bookings-per-sport";
        if (data.type == "day") {
          params = {
            "period-type": "dateWiseTotalBookingsPerSport",
            "start-date": data.from,
            "end-date": data.to,
          };
        } else if (data.type == "month") {
          params = {
            "period-type": "monthWiseTotalBookingsPerSport",
            "start-month": data.from,
            "end-month": data.to,
          };
        } else if (data.type == "year") {
          params = {
            "period-type": "yearWiseTotalBookingsPerSport",
            "start-year": data.from,
            "end-year": data.to,
          };
        }
      }
      this.$http
        .post(url, params)
        .then((response) => {
          if (data.chart == "users") {
            this.datas1.chartData = response.data.data;
            this.datas1.heighest = this.findHeighestValue(response.data.data);
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getAppUsageHistory() {
      this.datas3.loading = true;
      this.$http
        .get(this.rootUrl + "admin/dashboard/usage-history")
        .then((response) => {
          if (response.status == 200) {
            this.datas3.chartData = response.data.data;
            this.datas3.heighest = this.findHeighestValue(response.data.data);
            this.datas3.loading = false;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    findHeighestValue(data) {
      var largest = 0;
      data.forEach(function(arr) {
        if (typeof arr[1] != "undefined") {
          if (arr[1] > largest) {
            largest = arr[1];
          }
        } else {
          var obj = arr.data;
          largest = Object.values(obj).reduce(function(a, b) {
            return obj[a] > obj[b] ? a : b;
          });
        }
      });
      return Math.ceil(largest * 1.1);
    },
    getTopSelling() {
      this.$http
        .get(this.rootUrl + "admin/dashboard/top-selling-last-30dys")
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.table = response.data.data;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getCardsData() {
      this.$http
        .get("admin/dashboard/cards")
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            let data = response.data.data;
            this.users = data.users != null ? parseInt(data.users) : 0;
            this.events = data.events != null ? parseInt(data.events) : 0;
            this.participants =
              data.participants != null ? parseInt(data.participants) : 0;
            this.sales = data.sales != null ? parseInt(data.sales) : 0;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getAnalyticsByLocation() {
      this.locationAnalytics.loading = true;
      this.$http
        .get(
          this.rootUrl +
            "admin/dashboard/location-analytics" +
            (this.locationAnalytics.type != null
              ? "?type=" + this.locationAnalytics.type
              : "")
        )
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            // this.locationAnalytics.data = response.data.data;
            const data = response.data.data;
            let locationData = [];
            let heighest = 0;
            for (let k in data) {
              heighest = data[k] > heighest ? data[k] : heighest;
              let dt = [k != "" ? k : "Unknown", data[k]];
              locationData.push(dt);
            }
            this.locationAnalytics.data = locationData;
            this.locationAnalytics.heighest = heighest * 1.1;
            this.locationAnalytics.loading = false;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getAnalyticsByDevice() {
      this.deviceAnalytics.loading = true;
      this.$http
        .get(
          this.rootUrl +
            "admin/dashboard/device-analytics" +
            (this.deviceAnalytics.type != null &&
            this.deviceAnalytics.type != "All"
              ? "?type=" + this.deviceAnalytics.type
              : "")
        )
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            // this.deviceAnalytics.data = response.data.data;
            const data = response.data.data;
            let deviceData = [];
            let heighest = 0;
            for (let k in data) {
              heighest = data[k] > heighest ? data[k] : heighest;
              let dt = [k != "" ? k : "Unknown", data[k]];
              deviceData.push(dt);
            }
            this.deviceAnalytics.data = deviceData;
            this.deviceAnalytics.heighest = heighest * 1.1;
            this.deviceAnalytics.loading = false;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getAnalyticsByOs() {
      this.osAnalytics.loading = true;
      this.$http
        .get(
          this.rootUrl +
            "admin/dashboard/os-analytics" +
            (this.osAnalytics.type != null && this.osAnalytics.type != "All"
              ? "?os=" + this.osAnalytics.type
              : "")
        )
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            // this.osAnalytics.data = response.data.data;
            const data = response.data.data;
            let osData = [];
            let heighest = 0;
            for (let k in data) {
              heighest = data[k] > heighest ? data[k] : heighest;
              let dt = [k != "" ? k : "Unknown", data[k]];
              osData.push(dt);
            }
            this.osAnalytics.data = osData;
            this.osAnalytics.heighest = heighest * 1.1;
            this.osAnalytics.loading = false;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
  },
};
</script>

<style scoped></style>
